import Styles from './BackConfirmationCard.module.scss';
import { useState } from "react";
// Module imports.
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
// Components import.
import { useTranslation, ViewContext } from 'components/lib';
import { ConfirmationCard } from "../ConfirmationCard/ConfirmationCard";
import axios from 'axios';
import { useContext } from 'react';

export function BackConfirmationCard({ isSaveAvailable, isContainerLab = false, sessionId }) {

    const { t } = useTranslation();
    const viewContext = useContext(ViewContext);
    const [backButton, setBackButton] = useState(false);

    const body = isSaveAvailable ?
        t('Components.BackConfirmationCard.confirm.save.body') :
        t('Components.BackConfirmationCard.confirm.default.body');

    const title = isSaveAvailable ?
        t('Components.BackConfirmationCard.confirm.default.title') :
        t('Components.BackConfirmationCard.confirm.save.title');
    // for labs with container, container needs to be marked and deleted

    const onBackButton = () => {

        if (isContainerLab) {
            const formData = {
                sessionId
            };
            const options = {
                method: 'DELETE',
                url: `/api/container-instances`,
                headers: {
                    accept: 'application/json',
                },
                data: formData,
            };

            axios
                .request(options)
                .then(async function (response) {
                    localStorage.removeItem('sessionId');
                    window.history.back()
                })
                .catch((err) => {
                    console.log(err)
                    viewContext.notification.show(t('Components.BackConfirmationCard.error'))
                });
        } else {
            window.history.back()
        }
    }

    return (
        <>
            <button onClick={() => { setBackButton(true) }} className={Styles.backButton}>
                <FeatherIcon size="0.9em" icon="arrow-left" /> {t('Components.BackConfirmationCard.button')}
            </button>
            <ConfirmationCard
                title={title}
                body={body}
                showCard={backButton}
                setShowCard={setBackButton}
                handleConfirm={onBackButton}
            />
        </>
    )

}

